import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    none: translate({ id: 'order.status.missing' }),
    reportedTimeIn: translate({ id: 'orders.form.reportedTimeIn' }),
    reportedTimeOut: translate({ id: 'orders.form.reportedTimeOut' }),
  }))

  return api
}
